import { CmsLatestReactionAvatars } from './CmsLatestReactionAvatars';
import { CmsReactionsSummaryContainer } from './CmsReactions.styled';
import { CmsTotalReactionsHeading } from './CmsTotalReactionsHeading';

export function CmsReactionsSummary() {
  return (
    <CmsReactionsSummaryContainer>
      <CmsLatestReactionAvatars />
      <CmsTotalReactionsHeading />
    </CmsReactionsSummaryContainer>
  );
}
